import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';

import { apiEndpoint } from '@/app/app/constants/endpoints.const';
import { UserSettings, UserSettingsResponse } from '@/app/app/interfaces/api/user-settings';
import { SKIP_ERROR_TOAST, SKIP_LOADING_INDICATOR } from '@/shared/lib/core/interceptors/header-tokens';

// User-level settings, not tenant bound (see doc/user-settings-api.md). Background calls: no loading overlay, and
// failures are handled by the caller (the settings keep working locally) instead of showing an error toast.
@Service()
export class SettingsApi {
  http = inject(HttpClient);

  private readonly context = () => new HttpContext().set(SKIP_LOADING_INDICATOR, true).set(SKIP_ERROR_TOAST, true);

  public getSettings(): Observable<UserSettingsResponse> {
    return this.http.get<UserSettingsResponse>(`${apiEndpoint}/users/settings`, { context: this.context() });
  }

  // JSON Merge Patch: only the given keys change, null removes a key
  public patchSettings(patch: UserSettings): Observable<UserSettingsResponse> {
    return this.http.patch<UserSettingsResponse>(`${apiEndpoint}/users/settings`, patch, { context: this.context() });
  }
}
